<template>
  <div id="goods-detail">
    <!--    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>-->
    <div :class="['wrapper',!showHeader?'top':'']">
      <div class="topClass" v-if="showHeader">
        <div class="left" @click="ToHome()">
          <img class="leftlogo" src="../../../assets/home-logo.png" alt="">
          <p class="title">中消在线商城<span class="slogan">消防安全产品一站式采购平台</span></p>
        </div>
        <div class="right" @click="ToPerson()">
          <div class="center"></div>
        </div>
      </div>
      <!-- <div class="section section1">
        <div class="title">{{businessInfo.company_name}}<img :src="isVip()" /></div>
        <div class="auth">
          <div class="image"  v-for="(value,ii) in authImgs" :key="ii">
            <img :src="value" />
          </div>
        </div>
      </div> -->
      <div class="section section2">
        <swiper class="swiperGoods" v-if="goodsBanner.length >= 1" :options="swiperGoodsOptions" ref="swiperGoods">
          <swiper-slide v-for="(value,index) in goodsBanner" :key="index">
            <!--            <div :class="value" :style="{backgroundImage:'url('+value+')'}">-->
            <div class="bannerImg" @click="previewImgClick(index)">
              <img :src="value" />
              <!--              <span></span>-->
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <div class="section section3">
        <div class="price" v-show="firstGoodsInfo.telephone_bargain == 0">￥
          <span
            class="c-price">{{firstGoodsInfo.discount_price===undefined?this.utils.keepPoint(firstGoodsInfo.original_price/100):this.utils.keepPoint(firstGoodsInfo.discount_price/100)}}
          </span>
           <font class="innerFont" v-show="qiflag>1">起</font>&nbsp;&nbsp;
          <span class="o-price"
            v-show="firstGoodsInfo.discount_price!==undefined">￥{{this.utils.keepPoint(firstGoodsInfo.original_price/100)}}</span>
        </div>
        <div class="call" v-show="firstGoodsInfo.telephone_bargain == 1">电议</div>
        <div class="title">
          <img class="goods-comm-icon" v-if="goodsInfo.isVipSupplier&&goodsInfo.isVipSupplier==1" src="https://cdn.zxzx119.com/zxzx-mall-applet/image/ssvip-icon.png" alt="" srcset="">
          {{goodsInfo.product_name}}
        </div>
        <!--         <div class="freight" v-show="firstGoodsInfo.telephone_bargain === 0"><span>运费：</span>免邮费</div>-->
      </div>
      <!-- <div class="section section4">
        <div class="sheader"><div class="left"></div><div class="title">企业档案</div><div class="right"></div></div>
        <div class="row row1"><span>主营产品或服务&nbsp;&nbsp;</span>{{businessInfo.main_business!==undefined?businessInfo.main_business:'暂无'}}</div>
        <div class="row row2"><span>认&nbsp;&nbsp;&nbsp;证&nbsp;&nbsp;&nbsp;信&nbsp;&nbsp;&nbsp;息&nbsp;&nbsp;&nbsp;</span>{{authInfo}}</div>
        <div class="row row3"><span>所&nbsp;&nbsp;&nbsp;在&nbsp;&nbsp;&nbsp;地&nbsp;&nbsp;&nbsp;区&nbsp;&nbsp;&nbsp;</span>{{businessInfo.province+businessInfo.city+businessInfo.area}}</div>
        <div class="row row4"><span>经&nbsp;&nbsp;&nbsp;营&nbsp;&nbsp;&nbsp;证&nbsp;&nbsp;&nbsp;照&nbsp;&nbsp;&nbsp;</span>
          <img v-show="licenseImg.length>0" src="../images/icon-license.png" />
          <span v-show="licenseImg.length<=0" class="none">暂无</span>
        </div>
      </div> -->
      <div class="section section5">
        <div class="sheader">
          <div class="left"></div>
          <div class="title">产品参数</div>
          <div class="right"></div>
        </div>
        <div class="row row1"><span>品&nbsp;牌&nbsp;名&nbsp;称&nbsp;&nbsp;&nbsp;</span>{{goodsInfo.added.brand}}</div>
        <div class="row row2">
          <span>发货地&nbsp;&nbsp;&nbsp;</span>{{goodsInfo.added.province+goodsInfo.added.city+goodsInfo.added.area}}
        </div>
        <div v-if="goodsInfo.added.goods_material !==''" class="row row3">
          <span>材&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;质&nbsp;&nbsp;&nbsp;</span>{{goodsInfo.added.goods_material===''?'暂无':goodsInfo.added.goods_material}}
        </div>
        <div v-if="goodsInfo.added.mark !== ''" class="row row4">
          <span>备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注&nbsp;&nbsp;&nbsp;</span>{{goodsInfo.added.mark===''?'暂无':goodsInfo.added.mark}}
        </div>
      </div>
      <div class="section section6">
        <div class="sheader">
          <div class="left"></div>
          <div class="title">产品详情</div>
          <div class="right"></div>
        </div>
        <div class="introduce" id="contentIntroduce" v-html="goodsInfo.introduce"></div>
      </div>
    </div>
    <goodsButton v-show="firstGoodsInfo.telephone_bargain == 0" :phone="servicePhone" :cartCount="cartCount"
      @click="bottomClick"></goodsButton>
    <bottomButton v-show="firstGoodsInfo.telephone_bargain == 1" title="联系我们" state="1" @click="bottomClick2">
    </bottomButton>
    <goodsSelect :show="showGoodsSelect" :type="clickType" :goodsInfo="goodsInfo" @click="selGoodsClick"
      @hideClick="hideSelClick"></goodsSelect>
    <el-dialog title="查看联系方式" :visible.sync="checkContect" width="80%">
      <div class="title">
        <p class="tit">您采购的产品：</p>
        <input disabled maxlength="" class="input" type="text" v-model="productName">
        <p class="tit">您的手机号码：</p>
        <input maxlength="" class="numb" type="text" placeholder="请输入您的手机号方便商家联系您" v-model="numb">
        <div class="btnbox">
          <el-button class="btn" type="text" @click="sub(numb)">马上提交</el-button>
        </div>
      </div>
    </el-dialog>
    <Login :show="showLogin" @click="loginPopClick"></Login>
  </div>

</template>

<script>
import wxShare from '@/wx/weixin'
import { Toast } from 'mint-ui'
import { ImagePreview } from 'vant'
import mainHeader from '@/view/header'
import goodsButton from './goods-bottom'
import goodsSelect from './goods-select'
import Login from './pop-login'
import bottomButton from '@/components/bottom-button3'
// import AlertView from '@/components/alert-view'
export default {
  name: 'goods-detail',
  data () {
    return {
      tabHeight: 0,
      checkContect: false,
      productName: '',
      numb: null,
      servicePhone: '4001919119',
      showLogin: false,
      isLogin: 0,
      showGoodsSelect: false,
      clickType: 0,
      goodsId: this.$route.query.goodsId, // 商品id
      businessId: this.$route.query.businessId, // 企业id
      goodsInfo: { added: {} },
      firstGoodsInfo: {},
      goodsBanner: [],
      businessInfo: {},
      authImgs: [],
      licenseImg: '',
      authInfo: '',
      cartCount: 0, // 购物车类型数量
      limitNumb: 1,
      qiflag: false,
      swiperGoodsOptions: {
        direction: 'horizontal',
        loop: false,
        autoplay: false,
        observer: true,
        observeParents: true,
        initialSlide: 0,
        on: {
          click: function () {
            // console.log('index========' + this.realIndex)
            // let item = _this.bannersData[this.realIndex]
            // console.log('url====' + item.h5_ad_url)
            // if (item.h5_ad_url === undefined) {
            // } else {
            //   window.location.href = item.h5_ad_url
            // }
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      showHeader: true,
      isApp: 0
    }
  },
  methods: {

    checkLogin () {
      this.utils.get(this.companyUrl + '/ent/json', null, res => {
        localStorage.setItem('userinfo', JSON.stringify(res.data))
      })
    },
    ToHome () {
      console.log('主页')
      localStorage.setItem('tab', 0)
      this.$router.push({
        path: '/homePage/goodslist'
      })
    },
    ToPerson () {
      console.log('个人')
      localStorage.setItem('tab', 2)
      this.$router.push({
        path: '/homePage/personHomePage'
      })
    },
    isVip: function () { // vip图片
      if (this.businessInfo === {}) {
        return require('../images/icon-vip-n.png')
      }
      if (this.businessInfo.tails === undefined) {
        return require('../images/icon-vip-n.png')
      } else {
        if (this.businessInfo.tails.vip !== undefined && this.businessInfo.tails.vip === '1') {
          return require('../images/icon-vip-y.png')
        } else {
          return require('../images/icon-vip-n.png')
        }
      }
    },
    getAuthImgs: function () {
      var images = []
      // 企业认证图片
      if (this.businessInfo.tails.company === 1) {
        images.push(require('../images/icon-auth.png'))
      }
      // 资质图片
      if (this.businessInfo.tails.img !== undefined) {
        if (this.businessInfo.tails.img.indexOf(',')) {
          let array = this.businessInfo.tails.img.split(',')
          for (let i = 0; i < array.length; i++) {
            images.push('http://cdn.zxzx119.com/' + array[i])
          }
        } else {
          images.push('http://cdn.zxzx119.com/' + this.businessInfo.tails.img)
        }
      }
      this.authImgs = images
    },
    getAuthInfo: function () {
      let infoStr = ''
      infoStr = this.businessInfo.tails.company === 1 ? '企业认证 ' : ''
      infoStr += (this.businessInfo.tails.identity === 1 ? '身份认证 ' : '')
      for (let i = 0; i < this.businessInfo.tails.sign.length; i++) {
        let info = this.businessInfo.tails.sign[i]
        if (info.sign_type === '企业认证' && info.sign_status === '审核通过') {
          this.licenseImg = info.sign_file
        }
        if (info.sign_type === '资质认证' && info.sign_status === '审核通过') {
          infoStr += (this.businessInfo.tails.identity === 1 ? '资质认证 ' : '')
        }
      }
      if (infoStr === '') {
        infoStr = '未认证'
      }
      this.authInfo = infoStr
    },
    previewImgClick: function (index) { // 图片预览
      ImagePreview({
        images: this.goodsBanner,
        startPosition: index
        // closeable: true
      })
    },
    bottomClick: function (type) {
      console.log('bottomClick:', type, this.isApp)
      // 0 购物车 1加入购物车 2 立即购买
      this.clickType = type
      if (type === 0) {
        // 先检测登录状态 中消商城需额外跳转
        if (this.isLogin === 0) {
          if (this.isApp && this.isApp == 2) {
            console.log('this.uaCheck01')
            this.uaCheck()
          } else {
            this.showLogin = true
          }
        } else {
          if (this.isApp && this.isApp == 2) {
            this.uaCart()
          } else {
            this.showLogin = false
            this.$router.push({ path: '/homePage/shoppingCart', query: { isTab: 1 } })
          }
        }
      } else {
        this.showGoodsSelect = true
      }
    },
    bottomClick2 () {
      let appquery = this.$router.history.current.query.isApp
      if (this.isLogin === 0) {
        if (appquery && appquery == 2) {
          console.log('this.uaCheck02')

          this.uaCheck()
        } else {
          this.showLogin = true
        }
      } else {
        this.showLogin = false
        this.checkContect = true
        this.productName = this.goodsInfo.product_name
      }
    },
    sub (numb) {
      if (numb === null || numb === '') {
        Toast('请输入手机号')
      } else if (!(/^1[3456789]\d{9}$/.test(numb))) {
        Toast('请输入正确的11位手机号')
      } else {
        // let obj = {
        //   goods_id: this.goodsInfo.id,
        //   product_name: this.goodsInfo.product_name,
        //   customer_phone: parseInt(numb)
        // }
        this.utils.post(this.accountUrl + '/goodsEnquiry/newEnquiry?goods_id=' + this.goodsInfo.id + '&product_name=' + this.goodsInfo.product_name + '&customer_phone=' + numb, null, res => {
          this.checkContect = false
          this.numb = null
          Toast(res.message)
        })
      }
    },
    loginPopClick: function (type) { // 0 隐藏 1 登录成功 2 注册 3 忘记密码
      console.log('type：', type)
      this.showLogin = false

      if (type === 1) {
        this.isLogin = 1
        this.getCartList()
      }
      if (type === 2) {
        this.$router.push({ path: 'register' })
      }
      if (type === 3) {
        this.$router.push({ path: 'retrieve' })
      }
    },
    selGoodsClick: function (type, index, selectedNum) { // type 1加入购物车 2立即购买
      // 先检测登录状态
      if (this.isLogin === 0) {
        if (this.isApp && this.isApp == 2) {
          console.log('this.uaCheck03')

          this.uaCheck()
          return
        } else {
          this.showLogin = true
          return
        }
      }
      this.showLogin = false
      console.log('type------' + type)
      var info = this.goodsInfo.detailList[index]
      let spec = JSON.parse(info.spec_detail)
      // 价格
      var pricetype = 0
      var cPrice = info.original_price
      if (info.discount_price !== undefined) {
        pricetype = 1
        cPrice = info.discount_price
      }
      let count = parseInt(cPrice) * selectedNum
      var goodsArray = []
      var objInfo = {
        color: spec['颜色'],
        count: count,
        goods_id: info.goods_id,
        goods_weight: info.goods_weight,
        id: info.id,
        inventory: info.inventory,
        number: selectedNum,
        original_price: parseInt(info.original_price),
        price_type: pricetype, // 0 原价 1 折扣价
        product_cover: this.goodsInfo.product_cover,
        product_name: this.goodsInfo.product_name,
        spec: spec['规格'],
        spec_detail: info.spec_detail,
        telephone_bargain: info.telephone_bargain,
        unit_price: parseInt(cPrice),
        created_time: info.created_time,
        modified_time: info.modified_time
      }
      goodsArray.push(objInfo)
      console.log(goodsArray)
      var _this = this
      if (type === 1) {
        this.utils.post(this.companyUrl + '/shoppingCart/add', goodsArray, function (response) {
          _this.getCartList()
          Toast('添加成功')
        })
      }
      if (type === 2) {
        this.utils.post(this.companyUrl + '/zxOrder/settlementData', goodsArray, function (response) {
          let orderDetail = response.data
          orderDetail.forEach((val, index) => {
            orderDetail[index]['isNewMallOrder'] = false// 是否生成订单
          })
          var jsonStr = JSON.stringify(orderDetail)
          _this.$store.commit('setCommodity', jsonStr)
          _this.$store.commit('clearOrderId', '')
          _this.$router.push({ path: '/checkOrder' })
        })
      }
    },
    hideSelClick: function () {
      this.showGoodsSelect = false
    },
    loadData: function () {
      var _this = this
      // 商品信息
      let urlPath = this.accountUrl + '/goods/goodsDetail?goods_id=' + this.goodsId + '&userId=0'
      this.utils.GET(urlPath, function (response) {
        // var result = response.data
        _this.firstGoodsInfo = response.data.goods.detailList[0]
        _this.goodsInfo = response.data.goods
        _this.qiflag = response.data.goods.detailList.length
        console.log(_this.firstGoodsInfo)
        _this.goodsBanner = _this.goodsInfo.product_cover.split(',')
        if (_this.goodsBanner.length < 2) {
          _this.swiperGoodsOptions.pagination.el = null
        }
        _this.wxShareInfo()
        _this.setImageInfo()
      })
      // 供应商 企业信息
      let urlPath2 = this.accountUrl + '/supplier/detail?id=' + this.businessId
      this.utils.GET(urlPath2, function (response) {
        // var result = response.data
        _this.businessInfo = response.data
        _this.getAuthImgs()
        _this.getAuthInfo()
      })
    },
    setImageInfo: function () {
      // 图片处理
      setTimeout(() => {
        let conDom = document.getElementById('contentIntroduce')
        var maxWidth = document.body.clientWidth - 30
        // console.log('maxWidth-' + maxWidth)
        if (maxWidth) {
          var myimg
          var imgs = conDom.querySelectorAll('img')
          console.log(imgs)
          for (let i = 0; i < imgs.length; i++) {
            myimg = imgs[i]
            myimg.width = maxWidth
            myimg.minHeight = '10px'
            console.log(myimg)
          }
        }
      }, 50)
    },
    getCartList: function () {
      console.log('购物车-------------------------')
      var _this = this
      // 购物车列表
      let urlPath = this.companyUrl + '/shoppingCart/list?page=1&rows=999&type=2&order=1'
      this.utils.GET(urlPath, function (response) {
        var result = response.data.rows
        var countNum = 0
        for (let i = 0; i < result.length; i++) {
          countNum += result[i].list.length
        }
        _this.cartCount = countNum
      })
    },
    wxShareInfo: function () {
      // 微信 分享
      var imgUrl = this.goodsInfo.product_cover
      if (imgUrl.indexOf(',') >= 0) {
        imgUrl = this.goodsInfo.product_cover.split(',')[0]
      }
      wxShare.wxRegister(this.goodsInfo.product_name, '中消在线商城消防安全产品一站式采购平台', imgUrl)
    },
    androidTabHeight (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = parseInt(value)
      }
    },
    uaCheck () {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      let nowUrl = this.$router.history.current.path
      let iosApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        navigator.userAgent
      )
      if (isiOS) {
        if (iosApp) {
          console.log('toAppLogin-01')
          window.webkit.messageHandlers.toAppLogin.postMessage(nowUrl)
        } else {
          this.$router.replace({
            path: '/login'
          })
        }
      } else if (isAndroid) {
        if (window.zxzx) {
          // app内
          console.log('toAppLogin-01')
          window.zxzx.toAppLogin(nowUrl)
        } else {
          // 浏览器内
          this.$router.replace({
            path: '/login'
          })
        }
      }
    },
    uaCart () {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      if (isiOS) {
        window.webkit.messageHandlers.toAppCar.postMessage(null)
      } else if (isAndroid) {
        // app内
        window.zxzx.toAppCar()
      }
    }
  },
  components: {
    mainHeader,
    goodsButton,
    goodsSelect,
    bottomButton,
    Login
  },
  created () {
    console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
    this.isApp = this.$route.query.isApp ? parseInt(this.$route.query.isApp) : parseInt(localStorage.getItem('isApp'))
    if (this.utils.isIphoneOrPc == 'pc') {
      window.location.href = 'https://www.zxzx119.com/goodscompany/' + this.businessId + '?id=' + this.goodsId
    }
    if (this.$route.query.isApp == 1 && this.$route.query.type == 1) {
      localStorage.setItem('enterType', this.$route.query.type)
      localStorage.setItem('isApp', this.$route.query.isApp)
    }
    if (this.$route.query.isApp) {
      localStorage.setItem('isApp', this.$route.query.isApp)
      this.isApp = this.$route.query.isApp
    }
    if (this.$route.query.isApp == 1 || localStorage.getItem('isApp') == 1 ||
      this.$route.query.isApp == 2 || localStorage.getItem('isApp') == 2) {
      this.showHeader = false
    } else {
      this.showHeader = true
    }
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 ||
        parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  },
  mounted () {
    console.log('mounted')
    this.loadData()

    document.body.scrollTop = document.documentElement.scrollTop = 0

    var _this = this
    this.utils.isUserLogin(function (login) {
      if (login === 0) {
        _this.isLogin = 0
      } else {
        _this.isLogin = 1
        _this.getCartList()
        _this.checkLogin()
      }
    })
  }
}
</script>

<style lang='scss' scoped>
#goods-detail {
  font-size: 0;
}
 .goods-comm-icon{
      width: 45px;
      height: 13px;
      margin-right: 5px;
    }
.wrapper {
  padding-top: 70px;
  position: relative;
  background-color: #f6f6f6;
  padding-bottom: 80px;
}
.wrapper.top {
  padding-top: 0px;
}
.topClass {
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  background: #ffffff;
  line-height: 60px;
  padding: 0 0px 0 15px;
  font-size: 0;
  z-index: 100;
  border-bottom: 0.01rem solid #eeeeee;
}
.topClass .left {
  height: 60px;
  display: inline-block;
}
.topClass .title {
  display: inline-block;
  font-size: 14px;
  color: #000000;
  line-height: 14px;
  width: 167px;
  padding: 13px 0 0 10px;
}
.topClass .title .slogan {
  margin-top: 6px;
  display: inline-block;
  font-size: 12px;
  color: #bebebe;
  line-height: 12px;
}
.topClass .leftlogo {
  display: inline-block;
  max-height: 40px;
  max-width: 47px;
  vertical-align: top;
  margin-top: 10px;
  /* margin: 10px 15px 0 0; */
}
.topClass .right {
  float: right;
  height: 60px;
  width: 60px;
  text-align: center;
  border-left: 1px solid #eeeeee;
}
.topClass .right .center {
  display: inline-block;
  width: 40px;
  height: 36px;
  background: url("../../../assets/personCenter.png") no-repeat center center;
  background-size: cover;
  margin-top: 10px;
}
.section {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  border-bottom: solid #f6f6f6 1px;
  box-sizing: content-box;
}
.section1 {
  height: 60px;
}
.section1 .title {
  position: absolute;
  top: 10px;
  left: 15px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #000000;
}
.section1 .title img {
  margin-left: 10px;
  width: 10px;
  height: 10px;
}
.section1 .auth {
  position: absolute;
  top: 35px;
  left: 15px;
  right: 15px;
  height: 10px;
}
.section1 .auth .image {
  margin-top: -5px;
  float: left;
  height: 10px;
  margin-left: 5px;
}
.section1 .auth .image img {
  top: 20px;
  height: 10px;
  width: auto;
}
.section1 .auth .image:first-of-type {
  margin-left: 0px;
}
.section2 {
  /*height: 300px;*/
  background-color: #f9f9f9;
}
.section2 .swiperGoods {
  width: 100%;
  /*height: 300px;*/
  overflow: hidden;
}
.section2 .swiperGoods .bannerImg {
  /*height: 300px;*/
  /*width: 100%;*/

  width: 100%;
  height: 0;
  margin: 0 auto;
  padding-top: 100%;
  background-color: #ffffff;
}
.section2 .swiperGoods .bannerImg img {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.section3 {
  position: relative;
  padding-top: 1px;
  min-height: 50px;
  background-color: #ffffff;
}
.section3 .price {
  position: relative;
  margin: 10px 0 0 15px;
  height: 25px;
  line-height: 25px;
  font-size: 16px;
  color: #c41335;
  .c-price {
    font-size: 21px;
    font-weight: bold;
  }
  .innerFont{
    font-size: 16px;
    color: #bdbdbd;
  }
  .o-price {
    font-size: 14px;
    color: #bebebe;
    text-decoration: line-through;
  }
}
.section3 .call {
  position: relative;
  margin: 10px 0 0 15px;
  height: 25px;
  font-size: 19px;
  font-weight: bold;
  color: #c41335;
}
.section3 .title {
  position: relative;
  margin: 5px 15px 13px 15px;
  min-height: 25px;
  line-height: 23px;
  font-size: 14px;
  color: #000000;
  font-weight: bold;
}
.section3 .freight {
  position: relative;
  margin: 5px 0 15px 15px;
  min-height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #000000;
  font-weight: bold;
}
.section3 .freight span {
  color: #808080;
}
.sheader {
  position: relative;
  height: 50px;
  width: 100%;
  background: #f6f6f6;
}
.sheader .left {
  position: absolute;
  left: 15px;
  top: 25px;
  height: 1px;
  width: calc(50% - 55px);
  background-color: #dadada;
}
.sheader .right {
  position: absolute;
  left: calc(50% + 40px);
  top: 25px;
  height: 1px;
  width: calc(50% - 55px);
  background-color: #dadada;
}
.sheader .title {
  position: absolute;
  top: 0px;
  left: calc(50% - 40px);
  width: 80px;
  height: 50px;
  line-height: 50px;
  font-size: 12px;
  color: #808080;
  text-align: center;
}
.section4 {
  height: 180px;
}
.section4 .row {
  margin-left: 15px;
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #808080;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /*display: -webkit-box;*/
  /*-webkit-line-clamp: 2;*/
  /*-webkit-box-orient: vertical;*/
}
.section4 .row1 {
  margin-top: 5px;
}
.section4 .row span {
  color: #000000;
}
.section4 .row .none {
  color: #808080;
}
.section4 .row img {
  width: 20px;
  height: 14px;
}
.section5 {
  min-height: 180px;
}
.section5 .row {
  margin-left: 15px;
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #000000;
}
.section5 .row1 {
  margin-top: 5px;
}
.section5 .row span {
  color: #808080;
}
.section6 {
  min-height: 100px;
}
.section6 .introduce {
  padding: 15px;
  min-height: 100px;
  font-size: 14px;
  color: #000000;
}

.bottomHeight {
  display: block;
  width: 100%;
  background: #ffffff;
}

>>> .section2 .swiper-pagination {
  position: absolute;
  bottom: 1px;
  width: 100%;
  height: 25px;
}
>>> .swiper-pagination .swiper-pagination-bullet {
  /*width: 8px;*/
  /*height: 8px;*/
  margin-left: 6px;
  background: #808080;
  opacity: 1;
}

>>> .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #c41335;
}

/deep/ .el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    padding-top: 10px;
    background: #c41335;
    .el-dialog__title {
      color: #ffffff;
    }
    .el-dialog__headerbtn {
      top: 10px;
      .el-dialog__close {
        color: #ffffff;
      }
    }
  }
  .el-dialog__body {
    padding-top: 20px;
  }
  .btnbox {
    text-align: center;
    .btn {
      display: inline-block;
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding: 0;
    }
  }
  .tit {
    line-height: 18px;
    font-size: 14px;
    color: #000000;
    margin-bottom: 10px;
  }
  .input {
    width: 100%;
    line-height: 36px;
    height: 36px;
    display: inline-block;
    border: 1px solid #e4e7ed;
    text-indent: 5px;
    margin-bottom: 20px;
    color: gray;
    background: #f5f7fa;
  }
  .numb {
    width: 100%;
    line-height: 36px;
    height: 36px;
    display: inline-block;
    border: 1px solid #e4e7ed;
    text-indent: 5px;
    margin-bottom: 20px;
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/goods/goods-detail.vue